import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Skeleton, Typography } from '@mui/material';
import { BarChart } from '../../../shared';
import { CTR_BAR_CHART_OPTIONS } from './constants';
import { customCategories } from '../../../../utility';

const CTRChart = () => {
    const showBenchMark = [61, 150];
    const campaignCompanies = [150];

    const { company } = useSelector((state) => state.company) || {};
    const { dtcData } = useSelector((state) => state.paidSearch);
    const { isCostApiLoading } = useSelector((state) => state.webMatrix);

    const {
        isPaidSearchLoading, CTRBarChart, CTRBarByCampaignChart
    } =
        dtcData || {};
    const isLoading = isCostApiLoading || isPaidSearchLoading;

    const isCampaign = campaignCompanies.includes(company?.id);

    const currentChart = isCampaign ? CTRBarByCampaignChart : CTRBarChart;
    const categories = currentChart?.categories || [];
    const data = currentChart?.data || [];

    const updatedCategories = customCategories(categories);

    const barChartOptions = useMemo(() => {
        const hasBenchmark = showBenchMark.includes(company?.id);

        return {
            ...CTR_BAR_CHART_OPTIONS,
            xaxis: {
                ...CTR_BAR_CHART_OPTIONS.xaxis,
                categories: updatedCategories
            },
            plotOptions: {
                ...CTR_BAR_CHART_OPTIONS.plotOptions,
                bar: {
                    ...CTR_BAR_CHART_OPTIONS.plotOptions.bar,
                    columnWidth: updatedCategories.length > 10 ? '40%' : '50px'
                }
            },
            annotations:
                hasBenchmark && updatedCategories.length
                    ? {
                        yaxis: [
                            {
                                y: 4.5,
                                borderColor: '#007FFF',
                                strokeDashArray: 5,
                                label: {
                                    text: '4.50%',
                                    position: 'right',
                                    style: {
                                        color: '#007FFF',
                                        fontWeight: 600
                                    }
                                }
                            }
                        ]
                    }
                    : {}
        };
    }, [company?.id, updatedCategories]);

    const [chartKey, setChartKey] = useState(0);
    useEffect(() => {
        setChartKey((prev) => prev + 1);
    }, [company?.id]);

    return (
        <Box className="container-p-24-br-16 bg-gray-50 height-100">
            <Typography className="text-md-medium gray-900 mb-4">
                CTR (%)
            </Typography>

            <Box className="wh-100" id="ctr-chart">
                {isLoading ? (
                    <Skeleton height={400} variant="rectangular" width="100%" />
                ) : (
                    <BarChart
                        chartOptions={barChartOptions}
                        chartSeries={[
                            {
                                name: 'CTR',
                                data: Array.isArray(data) ? data : []
                            }
                        ]}

                        height="300px"
                        key={chartKey}
                    />
                )}
            </Box>
        </Box>
    );
};

export default CTRChart;
